import React, { useState, useEffect } from 'react';
import { Form, Button, Nav, Card } from 'react-bootstrap';
import UkiesAssets from '../Admin/UkiesAssets';

export default function UkiesFullsizeSlider({ componentSettings, setComponentSettings, onChange, selectedComponent, setSelectedComponent }) {
    const [activeSlideTab, setActiveSlideTab] = useState(0);
    const [showAssetSelector, setShowAssetSelector] = useState(false);
    const [isInitialized, setIsInitialized] = useState(false);
    const [draggedTab, setDraggedTab] = useState(null);
    const [dragOverTab, setDragOverTab] = useState(null);
    const apiToken = process.env.REACT_APP_UKIES_API_TOKEN;
    
    // Get current values with defaults
    const autoplay = componentSettings.autoplay !== undefined ? componentSettings.autoplay : true;
    const interval = componentSettings.interval || '5000';
    const showArrows = componentSettings.show_arrows !== undefined ? componentSettings.show_arrows : true;
    const showNavigation = componentSettings.show_navigation !== undefined ? componentSettings.show_navigation : true;
    const slides = Array.isArray(componentSettings.slides) ? componentSettings.slides : [];

    // Parse HTML content to extract slider configuration and slides
    const parseHTMLContent = (htmlContent) => {
        if (!htmlContent) return null;
        
        try {
            // Create a temporary DOM element to parse the HTML
            const parser = new DOMParser();
            const doc = parser.parseFromString(htmlContent, 'text/html');
            
            // Extract configuration from script tag
            const scriptTag = doc.querySelector('script');
            let config = {
                autoplay: true,
                interval: '5000',
                show_arrows: false,
                show_navigation: true,
                slides: []
            };
            
            if (scriptTag) {
                const scriptContent = scriptTag.textContent;
                
                // Extract autoplay
                if (scriptContent.includes("autoplay: 'play'") || scriptContent.includes('autoplay: true')) {
                    config.autoplay = true;
                } else if (scriptContent.includes('autoplay: false') || !scriptContent.includes('autoplay:')) {
                    config.autoplay = false;
                }
                
                // Extract interval
                const intervalMatch = scriptContent.match(/interval:\s*(\d+)/);
                if (intervalMatch) {
                    config.interval = intervalMatch[1];
                }
                
                // Extract arrows
                const arrowsMatch = scriptContent.match(/arrows:\s*(true|false)/);
                if (arrowsMatch) {
                    config.show_arrows = arrowsMatch[1] === 'true';
                }
                
                // Extract pagination (navigation)
                const paginationMatch = scriptContent.match(/pagination:\s*(true|false)/);
                if (paginationMatch) {
                    config.show_navigation = paginationMatch[1] === 'true';
                }
            }
            
            // Extract slides
            const slideElements = doc.querySelectorAll('.splide__slide');
            config.slides = Array.from(slideElements).map(slide => {
                const style = slide.getAttribute('style') || '';
                
                // Extract background image
                const bgImageMatch = style.match(/background-image:\s*url\(([^)]+)\)/);
                const background_image = bgImageMatch ? bgImageMatch[1].replace(/['"]/g, '') : '';
                
                // Extract background position
                const bgPositionMatch = style.match(/background-position:\s*(\d+)%\s+(\d+)%/);
                const background_position_X = bgPositionMatch ? parseInt(bgPositionMatch[1]) : 50;
                const background_position_Y = bgPositionMatch ? parseInt(bgPositionMatch[2]) : 50;
                
                // Extract strapline (preheader)
                const straplineEl = slide.querySelector('.slide-preheader, .preheader-text');
                const strapline = straplineEl ? straplineEl.textContent.trim() : '';
                
                // Extract title (header)
                const titleEl = slide.querySelector('.slide-header, .header-text');
                const title = titleEl ? titleEl.textContent.trim() : '';
                
                // Extract button
                const buttonEl = slide.querySelector('.slide-button button, .component-button button');
                const button_label = buttonEl ? buttonEl.textContent.trim() : '';
                
                const linkEl = slide.querySelector('.slide-button a, .component-button a');
                const button_link = linkEl ? linkEl.getAttribute('href') || '' : '';
                
                const button_color = buttonEl && buttonEl.classList.contains('highlight') ? 'highlight' : 'default';
                
                return {
                    background_image,
                    background_position_X,
                    background_position_Y,
                    strapline,
                    title,
                    button_label,
                    button_link,
                    button_color
                };
            });
            
            return config;
        } catch (error) {
            console.error('Error parsing HTML content:', error);
            return null;
        }
    };

    // HTML escaping function to prevent XSS
    const escapeHtml = (text) => {
        const div = document.createElement('div');
        div.textContent = text;
        return div.innerHTML;
    };

    // Generate HTML content from current form values
    const generateHTMLContent = () => {
        const slidesHTML = slides.map(slide => {
            const bgPosition = `${slide.background_position_X || 50}% ${slide.background_position_Y || 50}%`;
            const buttonClass = slide.button_color === 'highlight' ? ' class="highlight"' : '';
            
            // Escape user input to prevent XSS
            const escapedStrapline = escapeHtml(slide.strapline || '');
            const escapedTitle = escapeHtml(slide.title || '');
            const escapedButtonLabel = escapeHtml(slide.button_label || '');
            const escapedButtonLink = escapeHtml(slide.button_link || '');
            
            // Generate button HTML only if button_label is not empty
            const buttonHtml = slide.button_label ? `                        <div class='slide-button component component-button'>
                            <a href='${escapedButtonLink}'>
                                <button${buttonClass}>${escapedButtonLabel}</button>
                            </a>
                        </div>` : '';
            
            return `            <li class="component splide__slide" style="background-image:url(${slide.background_image || ''});background-position:${bgPosition};">
                <div class='structure structure-1 lg:structure-2 overlay-container items-end text-shadow'>
                    <div class='slide-container'>
                        <div class='slide-preheader white'>${escapedStrapline}</div>
                        <div class='slide-header'>${escapedTitle}</div>
                        <div class='slide-description'>
                            <div class='slide-metadata'></div>
                            <div class='slide-body'></div>
                        </div>
${buttonHtml}
                    </div>
                </div>
            </li>`;
        }).join('\n');

        const autoplayValue = autoplay ? "'play'" : "false";
        const arrowsValue = showArrows ? "true" : "false";
        const paginationValue = showNavigation ? "true" : "false";

        return `<div class='structure-fullwidth ukies-fullsize-slider-banner'>
    <section id="splide_fullsize_banner_home" class="splide splide:var-3" aria-label="Plaatjes">
      <div class="splide__track">
        <ul class="splide__list header-banner">
${slidesHTML}
        </ul>
      </div>
    </section>
  
    <script>
        /* Set ID for splide */
        let id ='splide_fullsize_banner_home';
    
        /* Set variables for splide element(s) */
        let element = document.getElementById(id);

        /* Check if not already mounted */
        if(!element.classList.contains('is-initialized')) {
            /* Configure splide */
            let splide = new Splide( '#'+element.id, {
                type: 'loop',
                pagination: ${paginationValue},
                arrows: ${arrowsValue},
                autoplay: ${autoplayValue},
                interval: ${interval},
                pauseOnHover: true,
                pauseOnFocus: true
            });
        
            /* Mount splide */
            splide.mount();
        } else {
            /* Log */
            console.log('Splide ' + id + ' was already mounted.');
        }
    </script>
</div>`;
    };

    // Initialize form values from HTML content on component mount
    useEffect(() => {
        if (selectedComponent?.content && !isInitialized) {
            const parsed = parseHTMLContent(selectedComponent.content);
            if (parsed) {
                // Update the component settings with parsed values
                setComponentSettings(prev => ({
                    ...prev,
                    autoplay: parsed.autoplay,
                    interval: parsed.interval,
                    show_arrows: parsed.show_arrows,
                    show_navigation: parsed.show_navigation,
                    slides: parsed.slides
                }));
            }
            setIsInitialized(true);
        }
    }, [selectedComponent?.content, isInitialized, setComponentSettings]);

    // Reset initialization when component changes
    useEffect(() => {
        setIsInitialized(false);
    }, [selectedComponent?.id]);

    // Handle simple field changes and update HTML content
    const handleFieldChange = (fieldKey, value) => {
        onChange(fieldKey, value);
        
        // Update HTML content after a brief delay to ensure state is updated
        setTimeout(() => {
            const updatedSettings = { ...componentSettings, [fieldKey]: value };
            const newContent = generateHTMLContentFromSettings(updatedSettings);
            
            // Update local component settings
            setComponentSettings(prev => ({
                ...prev,
                [fieldKey]: value,
                content: newContent
            }));
            
            // Update content in parent component
            onChange('content', newContent);
        }, 0);
    };

    // Generate HTML content from provided settings object
    const generateHTMLContentFromSettings = (settings) => {
        const settingsSlides = Array.isArray(settings.slides) ? settings.slides : [];
        const settingsAutoplay = settings.autoplay !== undefined ? settings.autoplay : true;
        const settingsInterval = settings.interval || '5000';
        const settingsShowArrows = settings.show_arrows !== undefined ? settings.show_arrows : true;
        const settingsShowNavigation = settings.show_navigation !== undefined ? settings.show_navigation : true;

        const slidesHTML = settingsSlides.map(slide => {
            const bgPosition = `${slide.background_position_X || 50}% ${slide.background_position_Y || 50}%`;
            const buttonClass = slide.button_color === 'highlight' ? ' class="highlight"' : '';
            
            // Escape user input to prevent XSS
            const escapedStrapline = escapeHtml(slide.strapline || '');
            const escapedTitle = escapeHtml(slide.title || '');
            const escapedButtonLabel = escapeHtml(slide.button_label || '');
            const escapedButtonLink = escapeHtml(slide.button_link || '');
            
            // Generate button HTML only if button_label is not empty
            const buttonHtml = slide.button_label ? `                        <div class='slide-button component component-button'>
                            <a href='${escapedButtonLink}'>
                                <button${buttonClass}>${escapedButtonLabel}</button>
                            </a>
                        </div>` : '';
            
            return `            <li class="component splide__slide" style="background-image:url(${slide.background_image || ''});background-position:${bgPosition};">
                <div class='structure structure-1 lg:structure-2 overlay-container items-end text-shadow'>
                    <div class='slide-container'>
                        <div class='slide-preheader white'>${escapedStrapline}</div>
                        <div class='slide-header'>${escapedTitle}</div>
                        <div class='slide-description'>
                            <div class='slide-metadata'></div>
                            <div class='slide-body'></div>
                        </div>
${buttonHtml}
                    </div>
                </div>
            </li>`;
        }).join('\n');

        const autoplayValue = settingsAutoplay ? "'play'" : "false";
        const arrowsValue = settingsShowArrows ? "true" : "false";
        const paginationValue = settingsShowNavigation ? "true" : "false";

        return `<div class='structure-fullwidth ukies-fullsize-slider-banner'>
    <section id="splide_fullsize_banner_home" class="splide splide:var-3" aria-label="Plaatjes">
      <div class="splide__track">
        <ul class="splide__list header-banner">
${slidesHTML}
        </ul>
      </div>
    </section>
  
    <script>
        /* Set ID for splide */
        let id ='splide_fullsize_banner_home';
    
        /* Set variables for splide element(s) */
        let element = document.getElementById(id);

        /* Check if not already mounted */
        if(!element.classList.contains('is-initialized')) {
            /* Configure splide */
            let splide = new Splide( '#'+element.id, {
                type: 'loop',
                pagination: ${paginationValue},
                arrows: ${arrowsValue},
                autoplay: ${autoplayValue},
                interval: ${settingsInterval},
                pauseOnHover: true,
                pauseOnFocus: true
            });
        
            /* Mount splide */
            splide.mount();
        } else {
            /* Log */
            console.log('Splide ' + id + ' was already mounted.');
        }
    </script>
</div>`;
    };
    
    // Handle slide array changes and update HTML content
    const handleSlidesChange = (newSlides) => {
        onChange('slides', newSlides);
        
        // Update HTML content
        setTimeout(() => {
            const updatedSettings = { ...componentSettings, slides: newSlides };
            const newContent = generateHTMLContentFromSettings(updatedSettings);
            
            // Update local component settings
            setComponentSettings(prev => ({
                ...prev,
                slides: newSlides,
                content: newContent
            }));
            
            // Update content in parent component
            onChange('content', newContent);
        }, 0);
    };
    
    // Add new slide
    const handleAddSlide = () => {
        const newSlide = {
            background_image: '',
            background_position_X: 50,
            background_position_Y: 50,
            strapline: '',
            title: '',
            button_label: '',
            button_link: '',
            button_color: 'default'
        };
        const newSlides = [...slides, newSlide];
        handleSlidesChange(newSlides);
        setActiveSlideTab(newSlides.length - 1);
    };
    
    // Remove slide
    const handleRemoveSlide = (index) => {
        const newSlides = slides.filter((_, i) => i !== index);
        handleSlidesChange(newSlides);
        // Adjust active tab if necessary
        if (activeSlideTab >= newSlides.length && newSlides.length > 0) {
            setActiveSlideTab(newSlides.length - 1);
        } else if (newSlides.length === 0) {
            setActiveSlideTab(0);
        }
    };
    
    // Move slide up
    const handleMoveSlideUp = (index) => {
        if (index === 0) return;
        const newSlides = [...slides];
        [newSlides[index - 1], newSlides[index]] = [newSlides[index], newSlides[index - 1]];
        handleSlidesChange(newSlides);
        setActiveSlideTab(index - 1);
    };
    
    // Move slide down
    const handleMoveSlideDown = (index) => {
        if (index === slides.length - 1) return;
        const newSlides = [...slides];
        [newSlides[index], newSlides[index + 1]] = [newSlides[index + 1], newSlides[index]];
        handleSlidesChange(newSlides);
        setActiveSlideTab(index + 1);
    };
    
    // Handle slide field changes
    const handleSlideFieldChange = (slideIndex, fieldKey, value) => {
        const newSlides = [...slides];
        newSlides[slideIndex] = {
            ...newSlides[slideIndex],
            [fieldKey]: value
        };
        handleSlidesChange(newSlides);
    };
    
    // Get tab label for slide
    const getSlideTabLabel = (slide, index) => {
        if (slide?.title) return slide.title;
        if (slide?.strapline) return slide.strapline;
        return `Slide ${index + 1}`;
    };

    // Get small version of background image for tab
    const getSlideTabImage = (slide) => {
        if (!slide?.background_image) return null;
        // Replace /w=3840 with /w=medium for smaller version
        return slide.background_image.replace('/w=3840', '/w=medium');
    };
    
    // Drag and drop handlers for tabs
    const handleTabDragStart = (e, index) => {
        setDraggedTab(index);
        e.dataTransfer.effectAllowed = 'move';
        e.dataTransfer.setData('text/html', e.target.outerHTML);
        
        // Add some visual feedback
        setTimeout(() => {
            e.target.style.opacity = '0.5';
        }, 0);
    };

    const handleTabDragOver = (e, index) => {
        e.preventDefault();
        e.dataTransfer.dropEffect = 'move';
        setDragOverTab(index);
    };

    const handleTabDragLeave = () => {
        setDragOverTab(null);
    };

    const handleTabDrop = (e, dropIndex) => {
        e.preventDefault();
        
        if (draggedTab === null || draggedTab === dropIndex) {
            setDraggedTab(null);
            setDragOverTab(null);
            return;
        }

        // Reorder slides
        const newSlides = [...slides];
        const [movedSlide] = newSlides.splice(draggedTab, 1);
        newSlides.splice(dropIndex, 0, movedSlide);
        
        // Update the slides
        handleSlidesChange(newSlides);
        
        // Update active tab to follow the moved slide
        if (activeSlideTab === draggedTab) {
            setActiveSlideTab(dropIndex);
        } else if (activeSlideTab > draggedTab && activeSlideTab <= dropIndex) {
            setActiveSlideTab(activeSlideTab - 1);
        } else if (activeSlideTab < draggedTab && activeSlideTab >= dropIndex) {
            setActiveSlideTab(activeSlideTab + 1);
        }
        
        setDraggedTab(null);
        setDragOverTab(null);
    };

    const handleTabDragEnd = (e) => {
        // Reset visual feedback
        e.target.style.opacity = '1';
        setDraggedTab(null);
        setDragOverTab(null);
    };
    
    // Handle asset selection for background image
    const handleAssetSelect = (asset) => {
        const imageUrl = asset.image_variations?.large 
            ? asset.image_variations.large.replace('/large', '/w=3840')
            : asset.url;
        
        handleSlideFieldChange(activeSlideTab, 'background_image', imageUrl);
        setShowAssetSelector(false);
    };
    
    return (
        <div>
            <style jsx>{`
                /* Add button styling with ukies green colors */
                .add-button-green {
                    background-color: var(--ukies-light-green) !important;
                    border-color: var(--ukies-light-green) !important;
                    color: white !important;
                }
                .add-button-green:hover:not(:disabled) {
                    background-color: var(--ukies-dark-green) !important;
                    border-color: var(--ukies-dark-green) !important;
                    color: white !important;
                }
                .add-button-green:focus:not(:disabled) {
                    background-color: var(--ukies-dark-green) !important;
                    border-color: var(--ukies-dark-green) !important;
                    color: white !important;
                    box-shadow: 0 0 0 0.2rem rgba(59, 79, 70, 0.25) !important;
                }
                .add-button-green:active:not(:disabled) {
                    background-color: var(--ukies-dark-green) !important;
                    border-color: var(--ukies-dark-green) !important;
                    color: white !important;
                }
                
                /* Drag and drop styling for tabs */
                .nav-link.dragging {
                    opacity: 0.5 !important;
                    transform: rotate(2deg) !important;
                    transition: transform 0.1s ease-in-out !important;
                }
                
                .nav-link.drag-over {
                    border-color: var(--ukies-dark-orange) !important;
                    border-width: 2px !important;
                    transform: scale(1.02) !important;
                    transition: all 0.1s ease-in-out !important;
                    box-shadow: 0 0 8px rgba(0, 0, 0, 0.2) !important;
                }
                
                .nav-link[draggable="true"]:hover {
                    cursor: grab !important;
                }
                
                .nav-link[draggable="true"]:active {
                    cursor: grabbing !important;
                }
            `}</style>
            {/* Slider Configuration Header */}
            <h6 className="mb-2 mt-3">
                Slider
            </h6>
            
                         {/* Autoplay Switch */}
             <Form.Group className="mb-1">
                 <Form.Check
                     type="switch"
                     id="autoplay-switch"
                     label="Automatisch"
                     checked={autoplay}
                     onChange={(e) => handleFieldChange('autoplay', e.target.checked)}
                 />
             </Form.Group>
             
             {/* Interval Select - Only show when autoplay is enabled */}
             {autoplay && (
                 <Form.Group className="mb-4">
                     <Form.Label>Tijd per slide</Form.Label>
                    <Form.Select
                        value={interval}
                        onChange={(e) => handleFieldChange('interval', e.target.value)}
                    >
                        <option value="1000">1 seconde</option>
                        <option value="2000">2 seconden</option>
                        <option value="3000">3 seconden</option>
                        <option value="4000">4 seconden</option>
                        <option value="5000">5 seconden</option>
                        <option value="6000">6 seconden</option>
                        <option value="7000">7 seconden</option>
                        <option value="8000">8 seconden</option>
                        <option value="9000">9 seconden</option>
                        <option value="10000">10 seconden</option>
                    </Form.Select>
                </Form.Group>
             )}
            
                         {/* Show Arrows Switch */}
             <Form.Group className="mb-3">
                 <Form.Check
                     type="switch"
                     id="show-arrows-switch"
                     label="Vorige/Volgende pijltjes"
                     checked={showArrows}
                     onChange={(e) => handleFieldChange('show_arrows', e.target.checked)}
                 />
             </Form.Group>
             
             {/* Show Navigation Switch */}
             <Form.Group className="mb-3">
                 <Form.Check
                     type="switch"
                     id="show-navigation-switch"
                     label="Navigatie (stipjes)"
                     checked={showNavigation}
                     onChange={(e) => handleFieldChange('show_navigation', e.target.checked)}
                 />
             </Form.Group>
            
            {/* Slides Section */}
            <Form.Group className="mb-4">
                                                                   <div className="d-flex justify-content-between align-items-center mb-3">
                      <h6 className="mb-0">
                          Slides
                      </h6>
                                             <Button 
                           variant="success" 
                           size="sm" 
                           onClick={handleAddSlide}
                           className="add-button-green"
                       >
                        + Slide toevoegen
                       </Button>
                 </div>
                
                {slides.length === 0 ? (
                    <div className="text-center py-4 border rounded bg-light">
                        <p className="text-muted mb-2">Geen slides toegevoegd</p>
                        <Button variant="primary" size="sm" onClick={handleAddSlide}>
                            Eerste slide toevoegen
                        </Button>
                    </div>
                ) : (
                    <div className="array-field-tabs">
                                                                         {/* Slide Tabs */}
                        <Nav variant="tabs" className="gap-1">
                            {slides.map((slide, index) => (
                                <Nav.Item key={index} className="p-0">
                                    <Nav.Link 
                                        active={activeSlideTab === index}
                                        onClick={(e) => {
                                            // Only change active tab if we're not dragging
                                            if (draggedTab === null) {
                                                setActiveSlideTab(index);
                                            }
                                        }}
                                        className={`d-flex align-items-center gap-2 p-1 ${
                                            draggedTab === index ? 'dragging' : ''
                                        } ${
                                            dragOverTab === index ? 'drag-over' : ''
                                        }`}
                                        draggable="true"
                                        onDragStart={(e) => handleTabDragStart(e, index)}
                                        onDragOver={(e) => handleTabDragOver(e, index)}
                                        onDragLeave={handleTabDragLeave}
                                        onDrop={(e) => handleTabDrop(e, index)}
                                        onDragEnd={handleTabDragEnd}
                                        style={{ cursor: 'grab' }}
                                        title="Sleep om de volgorde te wijzigen"
                                                                         >
                                         <div style={{ position: 'relative' }}>
                                             {getSlideTabImage(slide) ? 
                                                 <img 
                                                     src={getSlideTabImage(slide)} 
                                                     alt="Slide preview" 
                                                     style={{ 
                                                         width: '120px', 
                                                         height: '80px',
                                                         objectFit: 'cover',
                                                         borderRadius: '4px 4px 0px 0px',
                                                         opacity: activeSlideTab === index ? 1 : 0.5,
                                                         transition: 'opacity 0.2s ease-in-out',
                                                         pointerEvents: 'none' // Prevent image from interfering with drag
                                                     }}
                                                 />
                                                 : <div style={{
                                                     width: '120px', 
                                                     height: '80px', 
                                                     backgroundColor: 'var(--ukies-light-green)',
                                                     display:'flex',
                                                     alignItems:'center',
                                                     justifyContent:'center',
                                                     color:'white',
                                                     fontWeight:'bold',
                                                     borderRadius: '4px 4px 0px 0px',
                                                     pointerEvents: 'none'
                                                 }}>
                                                     <span>Nieuwe slide</span>
                                                 </div>
                                             }
                                         </div>
                                     </Nav.Link>
                                </Nav.Item>
                            ))}
                        </Nav>
                        
                                                 {/* Slide Content */}
                         <div className="tab-content-wrapper p-3">
                             {slides.length > 0 && slides[activeSlideTab] && (
                                 <div>
                                     {/* Slide Management Buttons */}
                                     <div className="d-flex justify-content-between align-items-center mb-3 pb-2" style={{ borderBottom: '1px solid #dee2e6' }}>
                                         <h6 className="mb-0">
                                             Slide {activeSlideTab + 1} van {slides.length}
                                         </h6>
                                         <div className="d-flex gap-2">
                                             {/* Move Left Button */}
                                             <Button
                                                 variant="outline-secondary"
                                                 size="sm"
                                                 onClick={() => handleMoveSlideUp(activeSlideTab)}
                                                 disabled={activeSlideTab === 0}
                                                 title="Verplaats naar links"
                                             >
                                                 <svg width="12" height="12" viewBox="0 0 16 16" fill="currentColor">
                                                     <path d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/>
                                                 </svg>
                                             </Button>
                                             {/* Move Right Button */}
                                             <Button
                                                 variant="outline-secondary"
                                                 size="sm"
                                                 onClick={() => handleMoveSlideDown(activeSlideTab)}
                                                 disabled={activeSlideTab === slides.length - 1}
                                                 title="Verplaats naar rechts"
                                             >
                                                 <svg width="12" height="12" viewBox="0 0 16 16" fill="currentColor">
                                                     <path d="m4.646 1.646 6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L9.293 8 3.646 2.354a.5.5 0 1 1 .708-.708z"/>
                                                 </svg>
                                             </Button>
                                                                                           {/* Delete Button */}
                                              <Button
                                                  variant="danger"
                                                  size="sm"
                                                  onClick={() => {
                                                      if (window.confirm('Weet je zeker dat je deze slide wilt verwijderen?')) {
                                                          handleRemoveSlide(activeSlideTab);
                                                      }
                                                  }}
                                                  title="Verwijder slide"
                                              >
                                                  Verwijderen
                                              </Button>
                                         </div>
                                     </div>
                                                                         {/* Background Image */}
                                     <Form.Group className="mb-3">
                                         <Form.Label>Achtergrond</Form.Label>
                                         <Form.Label style={{marginLeft:'1.5rem'}}>Positie</Form.Label>
                                        {/* Line 1: Image selection button + Position controls */}
                                        <div className="d-flex align-items-center gap-2 mb-2">
                                                                                         <Button 
                                                 variant="outline-secondary" 
                                                 onClick={() => setShowAssetSelector(true)}
                                                 className="flex-shrink-0"
                                                 style={{ 
                                                     filter: 'grayscale(100%)',
                                                     minWidth: '35.2px',
                                                     height: '35.2px',
                                                     padding: '0',
                                                     display: 'flex',
                                                     alignItems: 'center',
                                                     justifyContent: 'center',
                                                     marginRight: '3.2rem'
                                                 }}
                                             >
                                                 🖼️
                                             </Button>
                                            <div className="d-flex align-items-center gap-2">
                                                <div className="d-flex align-items-center gap-1">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-left-right" viewBox="0 0 16 16">
                                                        <path fillRule="evenodd" d="M1 11.5a.5.5 0 0 0 .5.5h11.793l-3.147 3.146a.5.5 0 0 0 .708.708l4-4a.5.5 0 0 0 0-.708l-4-4a.5.5 0 0 0-.708.708L13.293 11H1.5a.5.5 0 0 0-.5.5m14-7a.5.5 0 0 1-.5.5H2.707l3.147 3.146a.5.5 0 1 1-.708.708l-4-4a.5.5 0 0 1 0-.708l4-4a.5.5 0 1 1 .708.708L2.707 4H14.5a.5.5 0 0 1 .5.5"/>
                                                    </svg>
                                                                                                         <Form.Control
                                                         type="number"
                                                         value={slides[activeSlideTab]?.background_position_X || 50}
                                                         onChange={(e) => handleSlideFieldChange(activeSlideTab, 'background_position_X', parseInt(e.target.value))}
                                                         min="0"
                                                         max="100"
                                                         step="1"
                                                         placeholder="50"
                                                         style={{width: '60px'}}
                                                         disabled
                                                     />
                                                </div>
                                                <div className="d-flex align-items-center gap-1">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-up-down" viewBox="0 0 16 16">
                                                        <path fillRule="evenodd" d="M11.5 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L11 2.707V14.5a.5.5 0 0 0 .5.5m-7-14a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 1 1 .708-.708L4 13.293V1.5a.5.5 0 0 1 .5-.5"/>
                                                    </svg>
                                                    <Form.Control
                                                        type="number"
                                                        value={slides[activeSlideTab]?.background_position_Y || 50}
                                                        onChange={(e) => handleSlideFieldChange(activeSlideTab, 'background_position_Y', parseInt(e.target.value))}
                                                        min="0"
                                                        max="100"
                                                        step="1"
                                                        placeholder="50"
                                                        style={{width: '60px'}}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        {/* Line 2: Image URL */}
                                        <Form.Control
                                            type="text"
                                            value={slides[activeSlideTab]?.background_image || ''}
                                            onChange={(e) => handleSlideFieldChange(activeSlideTab, 'background_image', e.target.value)}
                                            placeholder="Enter image URL"
                                            className="mb-2 small-font-input"
                                            disabled
                                        />
                                        {/* Line 3: Image preview */}
                                        {slides[activeSlideTab]?.background_image && (
                                            <div style={{overflow:'hidden',width:'100%',aspectRatio:'3/1',display:'flex',alignItems:'center',justifyContent:'center'}}>
                                                <img 
                                                    src={slides[activeSlideTab].background_image} 
                                                    alt="Background image preview" 
                                                    style={{ 
                                                        width: '100%', 
                                                        transform: `translate(${50 - (slides[activeSlideTab]?.background_position_X || 50)}%, ${50 - (slides[activeSlideTab]?.background_position_Y || 50)}%)`,
                                                        cursor: 'pointer',
                                                        border: '1px solid #dee2e6',
                                                        borderRadius: '4px'
                                                    }}
                                                    onClick={() => window.open(slides[activeSlideTab].background_image, '_blank')}
                                                />
                                            </div>
                                        )}
                                    </Form.Group>
                                    
                                                                         {/* Strapline */}
                                     <Form.Group className="mb-3">
                                         <Form.Label>Strapline</Form.Label>
                                        <Form.Control
                                            type="text"
                                            value={slides[activeSlideTab]?.strapline || ''}
                                            onChange={(e) => handleSlideFieldChange(activeSlideTab, 'strapline', e.target.value)}
                                            placeholder="Enter strapline"
                                        />
                                    </Form.Group>
                                    
                                                                         {/* Title */}
                                     <Form.Group className="mb-3">
                                         <Form.Label>Titel</Form.Label>
                                        <Form.Control
                                            type="text"
                                            value={slides[activeSlideTab]?.title || ''}
                                            onChange={(e) => handleSlideFieldChange(activeSlideTab, 'title', e.target.value)}
                                            placeholder="Enter title"
                                        />
                                    </Form.Group>
                                    
                                                                         {/* Button Section */}
                                     <h6 className="mb-2 mt-4" style={{ borderBottom: '1px solid #dee2e6', paddingBottom: '8px' }}>
                                         Knop
                                     </h6>
                                     
                                                                           {/* Button Label and Color on same line */}
                                      <div className="row mb-3">
                                          <div className="col-8">
                                              <Form.Group>
                                                  <Form.Label>Label</Form.Label>
                                                 <Form.Control
                                                     type="text"
                                                     value={slides[activeSlideTab]?.button_label || ''}
                                                     onChange={(e) => handleSlideFieldChange(activeSlideTab, 'button_label', e.target.value)}
                                                     placeholder="Enter button label"
                                                 />
                                             </Form.Group>
                                         </div>
                                                                                   <div className="col-4">
                                              <Form.Group>
                                                  <Form.Label>Kleur</Form.Label>
                                                 <Form.Select
                                                     value={slides[activeSlideTab]?.button_color || 'default'}
                                                     onChange={(e) => handleSlideFieldChange(activeSlideTab, 'button_color', e.target.value)}
                                                 >
                                                     <option value="default">Groen</option>
                                                     <option value="highlight">Oranje</option>
                                                 </Form.Select>
                                             </Form.Group>
                                         </div>
                                     </div>
                                     
                                                                           {/* Button Link */}
                                      <Form.Group className="mb-3">
                                          <Form.Label>Link</Form.Label>
                                         <Form.Control
                                             type="text"
                                             value={slides[activeSlideTab]?.button_link || ''}
                                             onChange={(e) => handleSlideFieldChange(activeSlideTab, 'button_link', e.target.value)}
                                             placeholder="Enter button link"
                                         />
                                     </Form.Group>
                                </div>
                            )}
                        </div>
                    </div>
                                 )}
             </Form.Group>
             
             {/* Asset Selector Dialog */}
             <UkiesAssets
                 open={showAssetSelector}
                 setOpen={setShowAssetSelector}
                 onAssetSelect={handleAssetSelect}
                 token={apiToken}
             />
         </div>
     );
 } 